import React, { FC, useState, useEffect } from 'react';
import { SCUIContent } from '../../../atomic/organisms';
import './AuthorizationRuleManagement.scss';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import { SCUIAddRoleDialog, SCUIRoleEditDialog, SCUIUpdateRoleDialog, SCUIBulkRoleAuthorizationDialog, SCUIEndpointSearchDialog } from '../../../atomic/molecules';
import { SCUIRolesMainRow } from '../../../atomic/molecules/SCUIRolesMainRow/SCUIRolesMainRow';
import { SCUIButton } from '../../../atomic/atoms';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Paper, Grid, TextField } from '@mui/material';
import { OperatorQuery } from '../../../services/query';
import { ARM } from './authorizationRuleManagement.classes';

export const AuthorizationRuleManagement: FC = () => {
    const { t } = useTranslation();
    const [searchedRolesName, setSearchedRolesName] = React.useState('');
    const [rolesList, setRolesList] = useState<any>();
    const [searchedRolesList, setSearchedRolesList] = useState<any>();
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [openBulkAuthorizationModal, setOpenBulkAuthorizationModal] = React.useState(false);
    const [openEndpointSearchModal, setOpenEndpointSearchModal] = React.useState(false);
    const [openRoleEditModal, setOpenRoleEditModal] = React.useState(false);
    const [openUpdateRoleModal, setOpenUpdateRoleModal] = React.useState(false);
    const [selectedRole, setSelectedRole] = React.useState<any>(null);

    const onModalEditOpen = () => {
        setOpenEditModal(true);
    };
    const onModalEditClose = () => setOpenEditModal(false);

    const onBulkAuthorizationOpen = () => setOpenBulkAuthorizationModal(true);
    const onBulkAuthorizationClose = () => setOpenBulkAuthorizationModal(false);

    const onEndpointSearchOpen = () => setOpenEndpointSearchModal(true);
    const onEndpointSearchClose = () => setOpenEndpointSearchModal(false);

    const onRoleEditOpen = (role: any) => {
        setSelectedRole(role);
        setOpenRoleEditModal(true);
    };
    const onRoleEditClose = () => {
        setOpenRoleEditModal(false);
        setSelectedRole(null);
    };

    const onUpdateRoleOpen = (role: any) => {
        setSelectedRole(role);
        setOpenUpdateRoleModal(true);
    };
    const onUpdateRoleClose = () => {
        setOpenUpdateRoleModal(false);
        setSelectedRole(null);
    };

    const [refresh, setRefresh] = useState(false);

    const getRolesList = () => {
        OperatorQuery.GetRolesList()
            .then((res: any) => {
                if (res) {
                    let parsedData = res.model.data;
                    setRolesList(parsedData);
                    setSearchedRolesList(parsedData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    useEffect(() => {
        getRolesList();
    }, [refresh]);

    const requestSearchRole = (searchedVal: any) => {
        setSearchedRolesName(searchedVal.target.value);
        let filteredRoles = searchedRolesList.filter(
            (o: any) => o.roleNameKey.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setRolesList(filteredRoles);
    };
    const refreshRoles = () => {
        setRefresh((prevRefreshing) => !prevRefreshing);
    };
    return (
        <SCUIContent className={ARM.page}>
            <Box className={ARM.dialogAddRole}>
                <SCUIAddRoleDialog open={openEditModal} onClose={onModalEditClose} refresh={refreshRoles} />
            </Box>
            <Box className={ARM.dialogBulkAuthorization}>
                <SCUIBulkRoleAuthorizationDialog open={openBulkAuthorizationModal} onClose={onBulkAuthorizationClose} />
            </Box>
            <Box className={ARM.dialogEndpointSearch}>
                <SCUIEndpointSearchDialog open={openEndpointSearchModal} onClose={onEndpointSearchClose} />
            </Box>
            <Box className={ARM.dialogRoleEdit}>
                <SCUIRoleEditDialog open={openRoleEditModal} onClose={onRoleEditClose} role={selectedRole} />
            </Box>
            <Box className={ARM.dialogUpdateRole}>
                <SCUIUpdateRoleDialog
                    open={openUpdateRoleModal}
                    onClose={onUpdateRoleClose}
                    selectedRole={selectedRole}
                    refresh={refreshRoles}
                />
            </Box>
            <Grid container direction="row" className={ARM.root}>
                <Grid
                    className={ARM.titleBox}
                    size={{
                        lg: 7,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <h1 className={`headtxt ${ARM.title}`}>{t('dashboard.authorizationManagement')}</h1>
                </Grid>
                <Grid
                    className={ARM.addRoleBox}
                    size={{
                        lg: 5,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            flexWrap: 'wrap',
                            gap: 1,
                            justifyContent: { xs: 'stretch', sm: 'flex-end' },
                            alignItems: { xs: 'stretch', sm: 'center' },
                        }}
                    >
                        <SCUIButton
                            className={ARM.btnEndpointSearch}
                            text={t('authorizationManagement.endpointSearch.button')}
                            type="primary"
                            sizeType="default"
                            size={'m'}
                            showStartIcon
                            startIcon={<SearchIcon sx={{ fontSize: '18px' }} />}
                            onClick={onEndpointSearchOpen}
                        />
                        <SCUIButton
                            className={ARM.btnBulkAuthorization}
                            text={t('authorizationManagement.bulkAuthorization.button')}
                            type="primary"
                            sizeType="default"
                            size={'m'}
                            showStartIcon
                            startIcon={<AdminPanelSettingsIcon sx={{ fontSize: '18px' }} />}
                            onClick={onBulkAuthorizationOpen}
                        />
                        <SCUIButton
                            className={ARM.btnAddRole}
                            text={t('authorizationManagement.addRole')}
                            type="primary"
                            sizeType="default"
                            size={'m'}
                            showStartIcon
                            startIcon={<AddIcon sx={{ fontSize: '18px' }} />}
                            onClick={() => onModalEditOpen()}
                        />
                    </Box>
                </Grid>
                <Grid
                    className={ARM.searchBox}
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    size={{
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={ARM.inputSearch}
                        value={searchedRolesName}
                        onChange={(searchVal) => requestSearchRole(searchVal)}
                        fullWidth
                        placeholder={t('authorizationManagement.roleName')}
                    />
                </Grid>
                <Paper className={ARM.tablePaper} sx={{ padding: '2rem', margin: '2rem', width: '100%' }}>
                    <TableContainer component={Paper} className={ARM.tableContainer}>
                        <Table aria-label="operators" className={ARM.table}>
                            <TableHead className={ARM.tableHead}>
                                <TableRow key={'operatortable'} className={ARM.tableHeadRow}>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellRoleName}`}
                                        data-column="role-name"
                                    >
                                        {t('authorizationManagement.roleName')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellDescription}`}
                                        data-column="description"
                                    >
                                        {t('general.description')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellIsRequestable}`}
                                        data-column="is-requestable"
                                    >
                                        {t('roleApproval.isRequestable')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellEditRole}`}
                                        data-column="edit-role"
                                    >
                                        {t('authorizationManagement.editRole')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellAssignManager}`}
                                        data-column="assign-manager"
                                    >
                                        {t('roleManagement.assignRoleManager')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellEditUser}`}
                                        data-column="edit-user"
                                    >
                                        {t('authorizationManagement.editUser')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellEditAuthorization}`}
                                        data-column="edit-authorization"
                                    >
                                        {t('authorizationManagement.editAuthorization')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${ARM.tableHeadCell} ${ARM.tableHeadCellRemoveRole}`}
                                        data-column="remove-role"
                                    >
                                        {t('authorizationManagement.removeRole')}
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody className={ARM.tableBody}>
                                {rolesList?.map((row: any) => (
                                    <SCUIRolesMainRow
                                        key={row.roleId}
                                        row={row}
                                        refresh={refreshRoles}
                                        onRoleEdit={onRoleEditOpen}
                                        onRoleUpdate={onUpdateRoleOpen}
                                    />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
        </SCUIContent>
    );
};
